export default class StudentLoanCalculator {
    constructor(employee, salary, studentLoan) {
        this.employee = employee;
        this.salary = salary;
        this.studentLoan = studentLoan;
    }

    calculate() {
        if (!this.employee.studentLoanType) {
            return 0;
        }

        const grossSalary = this.salary.getGross('year');

        const studentLoanThreshold = this.studentLoan.getThreshold(this.employee.studentLoanType);

        if (grossSalary > studentLoanThreshold) {
            const deductableSalary = grossSalary - studentLoanThreshold;
            return deductableSalary * this.studentLoan.getRate();
        }

        return 0;
    }
}